// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import './uitls/rem'
import Vue from 'vue'
import App from './App'
// import 'babel-polyfill'
import router from './router/finalRouter'
import 'babel-polyfill'
import store from './store'//引入store
import {
  Menu, MenuItem, Submenu, Carousel,
  CarouselItem, Col, Pagination, Input, Button,
  MessageBox, Table, TableColumn, FormItem, Form, DatePicker, Radio, Message,
  Select, Option, Loading, Popover, Tooltip,Header,Divider,Dropdown,DropdownMenu,DropdownItem,
  Container,Tag,Aside,Main,Dialog,Tabs,TabPane,Checkbox 
} from 'element-ui'
import VueLazyload from 'vue-lazyload'
import "element-ui/lib/theme-chalk/index.css"
// import down  from 'downloadjs'
// Vue.use(down);
import mavonEditor from 'mavon-editor'
import 'mavon-editor/dist/css/index.css'
// use
Vue.use(mavonEditor)
Vue.use(Menu);
Vue.use(MenuItem);
Vue.use(Container);
Vue.use(Dialog);
Vue.use(Main);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Divider);
Vue.use(Header);
Vue.use(Aside);
Vue.use(Checkbox);
Vue.use(Submenu);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Col);
Vue.use(Pagination);
Vue.use(Input);
Vue.use(Button);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(FormItem);
Vue.use(Form);
Vue.use(DatePicker);
Vue.use(Radio);
Vue.use(Select);
Vue.use(Option);
Vue.use(Popover);
Vue.use(Tooltip);
Vue.use(Loading);
Vue.use(Tag);
Vue.use(Tabs);
Vue.use(TabPane);
// Vue.use(Tag);
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$message = Message;
Vue.prototype.$loading = Loading.service;

// 使用VueLazyload并传入相应的配置
Vue.use(VueLazyload, {
  error: 'https://ss0.bdstatic.com/70cFvHSh_Q1YnxGkpoWK1HF6hhy/it/u=4051317813,3063773569&fm=26&gp=0.jpg',
  loading: '/static/image/timg.gif',// 懒加载使用的图片
})
Vue.config.productionTip = false
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next();


})
import 'babel-polyfill'
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {App},
  template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/main.js